// API Configuration for all API calls
// In production, this will use REACT_APP_API_URL from environment variables
// In development, it defaults to localhost:5000

const getApiUrl = () => {
  // Use environment variable if set, otherwise default to localhost for development
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // For production, use relative URL (same domain)
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  // Development default
  return 'http://localhost:5000/api';
};

export const API_URL = getApiUrl();

// Helper function to create full API endpoint URLs
export const apiUrl = (endpoint) => {
  return `${API_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

export default API_URL;
